import React from "react";

export default function CartDrawer({
  open,
  cart,
  mrpMap,
  onClose,
  onRemove,
  onStartEnroll,
}) {
  const cartKeys = Object.keys(cart);

  // cart[id].price is the BASE price (excl. GST); mrpMap[id] is also base MRP
  const totals = cartKeys.reduce(
    (acc, id) => {
      const itemBase = cart[id].price;
      acc.base  += itemBase * cart[id].qty;
      if (mrpMap[id]) acc.saved += (mrpMap[id] - itemBase) * cart[id].qty;
      return acc;
    },
    { base: 0, saved: 0 },
  );

  const baseAmount = totals.base;                    // total base price
  const gstAmount  = Math.round(baseAmount * 0.05);  // GST = base × 5%
  const grandTotal = baseAmount + gstAmount;         // Grand Total = base + GST

  return (
    <>
      <div className={`cart-scrim${open ? " open" : ""}`} onClick={onClose} />
      <div className={`cart-drawer${open ? " open" : ""}`}>
        <div className="cart-top">
          <div className="cart-heading">Your Cart</div>
          <button className="cart-close" onClick={onClose}>
            ✕
          </button>
        </div>

        <div className="cart-body-scroll">
          {cartKeys.length === 0 ? (
            <div className="cart-empty">
              <div className="empty-ico">🛒</div>
              <div className="empty-txt">
                Your cart is empty.
                <br />
                Select a plan above to begin.
              </div>
            </div>
          ) : (
            cartKeys.map((id) => {
              const item    = cart[id];
              const itemBase = item.price;                         // base price
              const itemGst  = Math.round(itemBase * 0.05);       // 5% GST on base
              const itemTotal = itemBase + itemGst;               // total incl. GST
              return (
                <div className="cart-row" key={id}>
                  <div className="cart-row-info">
                    <div className="cart-row-name">{item.name}</div>
                    {item.nameSub && (
                      <div className="cart-row-namesub">{item.nameSub}</div>
                    )}
                    <div className="cart-row-qty">
                      Qty: {item.qty} × ₹{itemBase.toLocaleString("en-IN")}
                    </div>
                   
                  </div>
                  <div className="cart-row-price">
                    ₹{(itemBase * item.qty).toLocaleString("en-IN")}
                  </div>
                  <button className="cart-rm" onClick={() => onRemove(id)}>
                    ✕
                  </button>
                </div>
              );
            })
          )}
        </div>

        {cartKeys.length > 0 && (
          <div className="cart-foot">
            <div className="cart-subtotal-line">
              <span>Price:</span>
              <span>₹{baseAmount.toLocaleString("en-IN")}</span>
            </div>
            <div className="cart-saving-line">
              <span>Your savings vs Price:</span>
              <span>₹{totals.saved.toLocaleString("en-IN")}</span>
            </div>
            <div className="cart-gst-line">
              <span>GST:</span>
              <span>+ ₹{gstAmount.toLocaleString("en-IN")}</span>
            </div>
            <div className="cart-divider" />
            <div className="cart-total-line">
              <span className="ct-label"><b>Grand Total</b></span>
              <span className="ct-amount">
                ₹{grandTotal.toLocaleString("en-IN")}
              </span>
            </div>
            <button className="primary-btn" onClick={onStartEnroll}>
              Proceed to Enroll →
            </button>
          </div>
        )}
      </div>
    </>
  );
}
